import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import FeaturedCollection from './components/FeaturedCollection';
import PlatformFeatures from './components/PlatformFeatures';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <HomeSchemaOrg />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <VideoGrid />
        <FeaturedCollection />
        <PlatformFeatures />
      </main>
      <Footer />
    </>
  );
}

function HomeSchemaOrg() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '精品视频',
        url: 'https://www.jingpinvideo.com',
        description: '精品视频汇聚海量高质量视频内容，涵盖教育、娱乐、生活、职场等多元领域。',
        foundingDate: '2020',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'service@jingpinvideo.com',
          availableLanguage: ['Chinese'],
        },
        sameAs: [
          'https://weibo.com/jingpinvideo',
          'https://space.bilibili.com/jingpinvideo',
        ],
      },
      {
        '@type': 'WebSite',
        name: '精品视频',
        url: 'https://www.jingpinvideo.com',
        description: '精品视频在线观看 - 高清精品视频合集与推荐平台',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.jingpinvideo.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '精品视频 - 首页',
        url: 'https://www.jingpinvideo.com',
        description: '精品视频首页，精选推荐高质量视频内容，涵盖教育学习、娱乐影视、生活方式、职场技能等多元领域。',
        isPartOf: { '@id': '#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '精品视频平台提供哪些类型的视频内容？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '精品视频平台涵盖教育学习、娱乐影视、生活方式、职场技能、科技数码、音乐艺术、体育运动、原创精品等八大内容领域，为用户提供全方位的高质量视频内容。',
            },
          },
          {
            '@type': 'Question',
            name: '如何在精品视频平台上找到感兴趣的内容？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过首页的分类导航浏览不同领域的内容，也可以使用搜索功能直接查找感兴趣的视频。平台还提供精选推荐和精选合集，帮助您快速发现优质内容。',
            },
          },
          {
            '@type': 'Question',
            name: '精品视频平台的内容是否支持离线观看？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '是的，精品视频平台支持视频离线缓存功能，您可以在有网络时下载视频，在无网络环境下也能随时观看已缓存的精彩内容。',
            },
          },
          {
            '@type': 'Question',
            name: '精品视频平台的内容来源是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '精品视频平台的内容来自正版授权合作和原创出品两大渠道。我们与众多优质内容创作者和版权方建立了合作关系，确保平台上的每一部视频都经过严格筛选和授权。',
            },
          },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}